/* import __COLOCATED_TEMPLATE__ from './io-current.hbs'; */
import Component from '@glimmer/component';

export default class InputOffsetCurrentError extends Component {
  get nonInverting() {
    return this.args.model.chartHandler.data.errorDistribution.errorHeader === 'Non-Inverting Amplifier';
  }
}
